import React, { useEffect, useState } from "react";
import { useUser } from "../UserContext";
import {
  Box,
  Typography,
  Grid,
  Button,
  FormControlLabel,
  Switch,
} from "@mui/material";
import axios from "axios";

// Define notification events for each role
const notificationEvents = {
  BA: {
    "Event is booked": {},
    "New message received": {},
    "24 hours before event reminder": {},
  },
  Agency: {
    "New event added": {},
    "New message received": {},
  },
  Brand: {
    "New product launch": {},
    "New message received": {},
    "Event is booked": {},
  },
  account: {
    "Event is booked": {},
    "New message received": {},
    "Notify ABC of new event": {},
  },
};

// Define a type for user roles
type UserRole = keyof typeof notificationEvents;

const Notifications: React.FC = () => {
  const { currentUser } = useUser();
  const [preferences, setPreferences] = useState<any>({});

  useEffect(() => {
    const fetchPreferences = async () => {
      if (currentUser) {
        try {
          const response = await axios.get(
            `${import.meta.env.VITE_API_URL}/notifications/preferences/${
              currentUser.user_id
            }`
          );
          setPreferences(response.data); // Assuming the response contains the preferences
        } catch (error) {
          console.error("Error fetching notification preferences:", error);
        }
      }
    };

    fetchPreferences();
  }, [currentUser]);

  const handleSave = async () => {
    if (!currentUser) return; // Ensure currentUser is not null
    try {
      await axios.post(
        `${import.meta.env.VITE_API_URL}/notifications/preferences/${
          currentUser.user_id
        }`,
        preferences
      );
      console.log("Preferences saved successfully:", preferences);
    } catch (error) {
      console.error("Error saving preferences:", error);
    }
  };

  const renderPreferences = () => {
    if (!currentUser) return null;

    // Filter events based on user role
    const eventsForRole =
      notificationEvents[currentUser.role as UserRole] || {};

    return (
      <Grid container spacing={2}>
        {/* Header Row */}
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Typography variant="h6">Event</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h6">Email</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="h6">Text</Typography>
            </Grid>
          </Grid>
        </Grid>

        {/* Notification Events Rows */}
        {Object.entries(eventsForRole).map(([notification]) => (
          <Grid item xs={12} key={notification}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Typography variant="subtitle1">{notification}</Typography>
              </Grid>
              <Grid item xs={3}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={preferences[notification]?.email || false}
                      onChange={(e) => {
                        setPreferences((prev: any) => ({
                          ...prev,
                          [notification]: {
                            ...prev[notification],
                            email: e.target.checked,
                          },
                        }));
                      }}
                    />
                  }
                  label=""
                />
              </Grid>
              <Grid item xs={3}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={preferences[notification]?.text || false}
                      onChange={(e) => {
                        setPreferences((prev: any) => ({
                          ...prev,
                          [notification]: {
                            ...prev[notification],
                            text: e.target.checked,
                          },
                        }));
                      }}
                    />
                  }
                  label=""
                />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <Box sx={{ p: 2 }}>
      {renderPreferences()}
      <Button variant="contained" color="primary" onClick={handleSave}>
        Save Preferences
      </Button>
    </Box>
  );
};

export default Notifications;
